import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App.js'
import axios from 'axios'

axios.defaults.baseURL = "https://virtual-placement-server.herokuapp.com/"

ReactDOM.render(
  <App/>,
  document.getElementById('root')
);

